var React = require('react');

function UserMessageLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 31a9.5 9.5 0 119.5-9.5A9.52 9.52 0 0115 31zm0-17a7.5 7.5 0 107.5 7.5A7.51 7.51 0 0015 14z","key":0}),React.createElement("path",{"d":"M29 48H1a1 1 0 01-1-1 15 15 0 0130 0 1 1 0 01-1 1zM2 46h25.93A13 13 0 002 46zm29-18a1 1 0 01-1-1v-7h-3a1 1 0 110-2h4a1 1 0 011 1v5.77l7.34-6.52A1 1 0 0140 18h6V2H18v7a1 1 0 01-2 0V1a1 1 0 011-1h30a1 1 0 011 1v18a1 1 0 01-1 1h-6.62l-8.71 7.74A1 1 0 0131 28z","key":1}),React.createElement("path",{"d":"M25 11.5a1.5 1.5 0 111.5-1.5 1.51 1.51 0 01-1.5 1.5zm14 0a1.5 1.5 0 110-3 1.49 1.49 0 011.49 1.49 1.448 1.448 0 01-.43 1.06 1.51 1.51 0 01-1.06.45zm-7 0a1.5 1.5 0 010-3 1.49 1.49 0 011.49 1.49 1.448 1.448 0 01-.43 1.06 1.51 1.51 0 01-1.06.45z","key":2})]);
}

UserMessageLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = UserMessageLight;

UserMessageLight.default = UserMessageLight;
